import React, {PureComponent, Fragment} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {TextField} from '@material-ui/core';

const styles = ({spacing}) => {
    return {
        textField: {
            minWidth: "200px",
        },
        textFieldMargin: {
            marginRight: spacing(2),
        },
    };
};

const CONST = {
    minimumConfigurationIntegerValue: 1,
};

class RowsVisualizationConfiguration extends PureComponent {
    render() {
        const {
            classes,
            handleChange,
            primeNumbersCount,
            numbersPerRow,
            pixelsPerNumber,
        } = this.props;

        return (
            <Fragment>
                <TextField
                    value={numbersPerRow}
                    type='number'
                    label='Interval (integers per row)'
                    variant='outlined'
                    margin='dense'
                    onChange={handleChange('numbersPerRow')}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        min: 1,
                        step: 1,
                    }}
                    className={clsx(classes.textField, classes.textFieldMargin)}
                />
                <TextField
                    value={pixelsPerNumber}
                    type='number'
                    label='Point size (pixels)'
                    variant='outlined'
                    margin='dense'
                    onChange={handleChange('pixelsPerNumber')}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        min: 1,
                        step: 1,
                    }}
                    className={clsx(classes.textField, classes.textFieldMargin)}
                />
                <TextField
                    value={primeNumbersCount}
                    type='number'
                    label='Quantity of prime numbers'
                    variant='outlined'
                    margin='dense'
                    onChange={handleChange('primeNumbersCount')}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{
                        min: 1,
                        max: 1000000,
                        step: 1,
                    }}
                    className={clsx(classes.textField)}
                />
            </Fragment>
        );
    }
}

RowsVisualizationConfiguration.propTypes = {
    classes: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    primeNumbersCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    numbersPerRow: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pixelsPerNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const CONFIGURATION_CONST = Object.create(CONST);
export default withStyles(styles)(RowsVisualizationConfiguration);
